<template>
  <section
    v-if="!debugCamera"
    ref="inputs-overlay"
    class="inputs-overlay"
    @touchstart.prevent="touchStart"
    @mousedown.prevent="touchStart"
    @mouseup.prevent="endAction"
    @touchend.prevent="endAction"
  >
    <div
      v-show="uiState.showTrail"
      class="trail"
    >
      <div
        ref="dot-first"
        class="dot dot-first"
      />
      <div
        ref="dots"
      >
        <div
          v-for="index in dotsCount"
          :key="index"
          class="dot"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { disciplinePhasesManager } from '@/app/phases/DisciplinePhasesManager'
import { inputsManager } from '@powerplay/core-minigames'
import { WindowAspect } from '@powerplay/core-minigames-ui-ssm'
import { debugConfig } from '@/app/config'
import { DisciplinePhases } from '@/app/types'
import { uiState } from '@/stores'

interface Dot {
  x: number
  y: number
  node: HTMLDivElement
}

export default defineComponent({
  name: 'MobileInputs',
  mixins: [WindowAspect],
  data() {

    return {
      uiState: uiState(),
      dotsCount: 500,
      dots: [] as Dot[],
      dotIndex: 0
    }

  },
  computed: {
    debugCamera() {

      return debugConfig.debugCamera

    }
  },
  mounted() {

    const dots = this.$refs.dots.children as HTMLCollection

    for (const dot of dots) {

      this.dots.push({
        x: 0,
        y: 0,
        node: dot
      })

    }

    uiState().$subscribe(() => {

      this.draw(this.$refs['dot-first'] as HTMLDivElement)

    })

  },
  methods: {
    touchStart(e: MouseEvent | TouchEvent) {

      console.warn('TOUCH START')

      if (disciplinePhasesManager.actualPhase === DisciplinePhases.draw) {

        const element = this.$refs['inputs-overlay'] as HTMLElement
        const offsetTop = document.documentElement.scrollTop - element.getBoundingClientRect().top
        const offsetLeft = document.documentElement.scrollLeft - element.getBoundingClientRect().left
        disciplinePhasesManager.phaseDraw?.startDraw(e, {
          x: offsetLeft,
          y: offsetTop
        })

      }
      this.reset()
      if (this.isMobile()) {

        disciplinePhasesManager.handleInputs()

      }

    },

    endAction() {

      if (disciplinePhasesManager.actualPhase === DisciplinePhases.draw) {

        disciplinePhasesManager.phaseDraw?.endDraw()

      }
      if (this.isMobile()) {

        // musime dat manulane ukoncenie buttonu, aby sa ukoncil takisto actionPressed v inputs
        inputsManager.handleMouseUp()

      }

    },
    draw(dotFirst: HTMLElement) {

      if (uiState().showTrail) {

        const x = uiState().trailX
        const y = uiState().trailY
        if (x === 0 && y === 0) return

        const dot = this.dots[this.dotIndex]

        dot.x = x
        dot.y = y

        dot.node.style.display = 'block'
        dot.node.style.left = `${dot.x}px`
        dot.node.style.top = `${dot.y}px`
        if (this.dotIndex === 0) {

          dotFirst.style.display = 'block'
          dotFirst.style.left = `${dot.x}px`
          dotFirst.style.top = `${dot.y}px`

        }

        this.dotIndex += 1
        this.dotIndex %= this.dotsCount

        for (let i = 1; i <= this.dotIndex; i++) {

          const index = (this.dotIndex - i)
          if (index < 0) return
          const dotObject = this.dots[index]
          dotObject.node.style.opacity = `${1 - i * 0.9 / this.dotIndex}`

        }


      }

    },
    reset() {

      this.dotIndex = 0
      this.dots.forEach((dot) => {

        dot.node.style.display = 'none'

      })

    }
  }
})
</script>

<style lang="less" scoped>
  .inputs-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height:100%;
    pointer-events: auto;
  }
  .trail {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height:100%;
    pointer-events: auto;
  }
  .dot {
    position: absolute;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: white;
    display: none;
    transform: translate(-50%, -50%);

    &.dot-first {
      background: transparent;
      border: 3px solid transparent;
      outline: 3px solid white;
    }
  }

</style>
